import { render, staticRenderFns } from "./AfterOpeningTutoring.vue?vue&type=template&id=1c419dad&scoped=true"
import script from "./AfterOpeningTutoring.vue?vue&type=script&lang=js"
export * from "./AfterOpeningTutoring.vue?vue&type=script&lang=js"
import style0 from "./AfterOpeningTutoring.vue?vue&type=style&index=0&id=1c419dad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c419dad",
  null
  
)

export default component.exports